/**
 * The text a metadata VALUE may carry: anything Postgres can store.
 *
 * Two things are legal in a JSON string and refused by the database: U+0000,
 * which `jsonb` rejects as `22P05 unsupported Unicode escape sequence`, and an
 * unpaired UTF-16 surrogate, which has no UTF-8 encoding at all. Either one in a
 * metadata value made the WHOLE document write fail as an opaque 500. Metadata
 * values are short filter attributes, never prose, so a value holding either is
 * refused with this rule rather than repaired: a silently rewritten value would
 * stop matching the filter its owner writes against it.
 */
export const DOCUMENT_METADATA_VALUE_TEXT_RULE =
  "a metadata value must not contain a NUL (U+0000) or an unpaired surrogate, which cannot be stored";
